module.exports = "../../static/img/card1.9a94e9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobile/card1.png
// module id = 6YE8
// module chunks = 1